var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-share",
      class: { "product-share--open": _vm.shadowOpen }
    },
    [
      _c(
        "button",
        {
          on: {
            click: function() {
              _vm.shadowOpen = !_vm.shadowOpen
              _vm.$emit("input", _vm.shadowOpen)
            }
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.shadowOpen,
                  expression: "!shadowOpen"
                }
              ],
              key: "share",
              staticClass: "link-text"
            },
            [_vm._v("Share")]
          ),
          _c("icon", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shadowOpen,
                expression: "shadowOpen"
              }
            ],
            key: "close",
            attrs: { name: "close", size: "20px" }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shadowOpen,
              expression: "shadowOpen"
            }
          ],
          staticClass: "product-share__icon-container"
        },
        [
          _c(
            "a",
            {
              staticClass: "product-form__share-icon",
              attrs: {
                href: _vm.shareLinks.facebook,
                target: "_blank",
                "aria-label": "Facebook"
              }
            },
            [_c("icon", { attrs: { name: "facebook_pdp", size: "20px" } })],
            1
          ),
          _c(
            "a",
            {
              staticClass: "product-form__share-icon",
              attrs: {
                href: _vm.shareLinks.twitter,
                target: "_blank",
                "aria-label": "Twitter"
              }
            },
            [_c("icon", { attrs: { name: "twitter_pdp", size: "20px" } })],
            1
          ),
          _c(
            "a",
            {
              staticClass: "product-form__share-icon",
              attrs: {
                href: _vm.shareLinks.pinterest,
                target: "_blank",
                "aria-label": "Pinterest"
              }
            },
            [_c("icon", { attrs: { name: "pinterest_pdp", size: "20px" } })],
            1
          ),
          _c(
            "a",
            {
              staticClass: "product-form__share-icon",
              attrs: {
                href: _vm.shareLinks.email,
                target: "_blank",
                "aria-label": "Email"
              }
            },
            [_c("icon", { attrs: { name: "email_pdp", size: "20px" } })],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }